import { InputMask, format } from '@react-input/mask';
import PropTypes from 'prop-types';
import React from 'react';
import TrueLinkTextInput from 'react/shared/components/true_link/main/form/text_input/TrueLinkTextInput';

export default function TrueLinkMaskedTextInput(props) {
  // Mask Formatting Examples
  // ssn -> 999-99-9999
  // ssn-last4 -> 9999
  // dob -> 99/99/9999
  // card -> 9999
  // ein -> 99-9999999
  // mobile -> 999-999-9999
  // zip -> 99999
  // phone -> (999) 999-9999

  const { value, mask, onChange, simpleInput, ...rest } = props;
  const replacement = { _: /\d/ };
  const formattedMask = mask.replace(/9/g, '_');
  const formattedValue = format(value || '', { mask: formattedMask, replacement });

  if (simpleInput) {
    return <InputMask {...rest} mask={formattedMask} replacement={replacement} />;
  }

  return (
    <InputMask
      {...rest}
      component={TrueLinkTextInput}
      mask={formattedMask}
      onChange={onChange}
      replacement={replacement}
      showMask
      value={formattedValue}
    />
  );
}

TrueLinkMaskedTextInput.propTypes = {
  errorOverride: PropTypes.bool,
  labelAdornment: PropTypes.node,
  labelText: PropTypes.string,
  mask: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  setFieldTouched: PropTypes.func,
  placeholder: PropTypes.string,
  simpleInput: PropTypes.bool,
};
